<template>
   <div  class='barra-lateral-direita' v-if='getShowBarRight'>
        <div class='menu-lateral-direito' >
            <form class='share-client direita' @submit.prevent>

                <!--<input class='esquerda input-button submit-reset ' type='submit'>-->

				<div class="form-group">
					<img src='/imgs/icons/company.svg' class='esquerda img'>
					<input  @click.prevent v-model="search" class='esquerda input-text form-control round-input' type='text' placeholder="busca cliente">
				</div>

                <div class='area-share'>
                    <div  @click="chooseAndInsertClient(client.id);getPhones(client.id)" class='show-share' v-for="client in allClients" :key='client.id'>
                        <div v-if="client" class='conteudo-share'>{{client.fantasy_name}}</div>
                    </div>
                </div>
            </form>
            <div>
                <div class="text-center">
                    <div class='espaco-cima-baixo'>
                        <p class='title' id="customerName">{{ (preSelectShow && preSelectShow.fantasy_name != null)? preSelectShow.fantasy_name : 'Cliente' }}</p>
                        <p class='sublinhado-embaixo cnpj'>{{ (preSelectShow && preSelectShow.cpf_cnpj != null)? cnpj : '00.000.000/0000-00' }}</p>
                        <p>
                            {{ (preSelectShow && preSelectShow.address != null)? preSelectShow.address : 'rua' }}
                            {{ (preSelectShow && preSelectShow.number != null)? preSelectShow.number : 'numero' }},
                            {{ (preSelectShow && preSelectShow.district != null)? preSelectShow.district: 'bairro' }},
                            {{ (preSelectShow)? preSelectShow.city : 'cidade' }}
                        </p>
                    </div>
                    <div class='second-client espaco-cima-baixo'>
                        <div class='direita'>
                            <img src='/imgs/icons/telephone-white.svg' class='esquerda img'>
                            <p class="esquerda">{{ (preSelectShow && phone1 != null)? phone1 : '(--) - ---- ----' }}</p>
                        </div>
                        <div class='direita'>
                            <img src='/imgs/icons/telephone-white.svg' class='esquerda img'>
                            <p class="esquerda">{{ (preSelectShow && phone2 != null)? phone2 : '(--) - ---- ----' }}</p>
                        </div>
                    </div>
					<select-product></select-product>

                    <div class='wpp-call' @click="open_client">
                        <div class="direita hover-change-color-pointer pad-5">
                            <img src='/imgs/icons/wpp-white.svg' class="esquerda icon-user">
                            <p class='esquerda'>Abrir Conversa</p>
                        </div>
                    </div>
                </div>
                <slot></slot>
            </div>
        </div>

    </div>

</template>
<script>
import {mapGetters,mapActions, mapState, mapMutations} from 'vuex';
export default {

    data(){
        return{
            search:'',
            // cnpj_real:'',
            cnpj: '',
            phone1: '',
            phone2: ''
        }
    },
    watch:{
        search:function(value){
            if(!value ){
                event.preventDefault();
                this.clearAllClients();
                return
            }
            // this.cnpj_real = value.replace(/[^0-9]/g,'')
            this.fetchClients(this.search.toLowerCase());
        },
        // "preSelectShow.cpf_cnpj": function(){
        //     if (this.preSelectShow){
        //         this.preSelectShow.cpf_cnpj.replace(/\D/g, "")
        //         .replace(/^(\d{2})(\d)/, "$1.$2")
        //         .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
        //         .replace(/\.(\d{3})(\d)/, ".$1/$2")
        //         .replace(/(\d{4})(\d)/, "$1-$2")
        //         .replace(/(-\d{2})\d+?$/, '$1');
        //     }
        // }
    },
    computed:{

        ...mapGetters([
            'allClients',
            'getShowBarRight',
            'preSelectShow',
            'getCnpj',
            'getShowSpearhead',
            'oneClient'

        ])
    },
    methods:{
        ...mapActions([ 
            'fetchClients',
            'chooseClient',
            'fetchProtocol',
            'clearAllClients',
            'chooseClientCnpj',
            'setShowSpearhead',
            'setShowBarRight',
            'preselectClient',
            'startConversation'
        ]),
        testem(client){
            console.log("entrou aqui");
            console.log(client);
        },
        chooseAndInsertClient(id){
            
            this.allClients.forEach(x => {
                if(x.id == id){
                    // this.chooseClient(x);

                    this.preselectClient(x);
                    // this.chooseClientCnpj(x.cpf)
                    this.fetchProtocol();
                }
            })
            this.clearAllClients();
        },
        bla(event){
            event.preventDefault();
        },
        open_client(){

            if(this.phone1){
                this.startConversation(this.preSelectShow);
            }

        },

        getPhones(id){
            axios.get(`/getPhones?id=${id}`).then(({data})=>{
                this.phone1 = data.phone1
                this.phone2 = data.phone2
            })
            this.cnpj = this.preSelectShow.cpf_cnpj.replace(/\D/g, "")
            .replace(/^(\d{2})(\d)/, "$1.$2")
            .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
            .replace(/\.(\d{3})(\d)/, ".$1/$2")
            .replace(/(\d{4})(\d)/, "$1-$2")
            .replace(/(-\d{2})\d+?$/, '$1');
        }

    }

}

</script>

<style>
#customerName {
    font-size: 16px;
}
.barra-lateral-direita{
	background-color: #CCCCCC;
	width: 230px;
	padding:15px 5px 15px 5px;
	text-align: center;
}
@media screen and (max-width: 720px) {
	.barra-lateral-direita{
		padding: 15px 5px 15px 5px;
		text-align: center;
	}
}
@media screen and (max-width: 1024px) {
	.barra-lateral-direita{
		background-color: #CCCCCC;
		padding: 15px 5px 15px 5px;
		text-align: center;
	}
}
.menu-lateral-direito{
	width: 100%;
	color:white;
}
.share-client input[type='submit']{
	background-image: url('/imgs/icons/search-white.svg');
	background-repeat: no-repeat;
	margin: 0;
	background-position: center;
	background-size: 20px 20px;
}
.area-share{
	position: absolute;
    width: 95%;
}
.show-share{
	position: absolute;
	z-index: 1;
	display: contents;
	color: black;
}
.conteudo-share{
	background-color: white;
	border:solid 1px black;
    border: none;
    padding: 0.25em;
}
.conteudo-share:hover{
	background-color: gray;
}
.espaco-cima-baixo p, .espaco-cima-baixo{
	margin: 16px 0 10px 0;
}
.sublinhado-embaixo{
	border-bottom:solid 1px white;
	padding: 10px 0 10px 0;
}
</style>



<style scoped>
.round-input{
    border-radius: 0.25em !important;
}
.wpp-call{
    margin-top: 1em;
}
.wpp-call:hover{
    color: gray;
}
</style>
